module.exports = __webpack_public_path__ + "static/media/2D_Art.913defd3.png";